/**
 * Фильтры договоров.
 */
export enum ContractsFilters {
  /**
   * Фильтр не указан (все)
   */
  None = 0,

  /**
   * Допускает операцию списания.
   */
  WithdrawEnable = 1,

  /**
   * Не допускает операцию списания.
   */
  WithdrawDisable = 2,

  /**
   * Допускает операцию зачисления.
   */
  DepositEnable = 4,

  /**
   * Не допускает операцию зачисления.
   */
  DepositDisable = 8,

  /**
   * Счета до востребования.
   */
  TypeDeposit = 16,

  /**
   * Cрочные счета.
   */
  TypeTime = 32,

  /**
   * Текущие счета.
   */
  TypeCurrent = 64,

  /**
   * Карточные счета
   */
  TypeCard = 128,

  /**
   * Открытые счета
   */
  StateOpened = 256,

  /**
   * Закрытые счета
   */
  StateClosed = 512,

  /**
   * основная валюта страны
   */
  CurrencyMain = 1024,

  /**
   * Прочие валюты мира
   */
  CurrencyOthers = 2048,

  /**
   *Кредитные счета
   */
  TypeCredit = 4096,
  
  /** Долларовые счета */
  CurrencyUsd = 8192,

  /** Евровые счета */
  CurrencyEur = 16384,

  /** Юань счета */
  CurrencyCny = 32768,

  /** Франковые счета */
  CurrencyChf = 65536,

  /**
   * Все типы счетов
   */
  TypeAll = TypeDeposit | TypeTime | TypeCurrent | TypeCard | TypeCredit,

  /**
   * Игнорируем признак списания
   */
  WithdrawAll = WithdrawEnable | WithdrawDisable,

  /**
   * Игнорируем признак пополнения
   */
  DepositAll = DepositEnable | DepositDisable,

  /**
   * Все типы операций со счетом
   */
  StateAll = StateOpened | StateClosed,

  /**
   * Все валюты всех стран всех миров вселенной
   */
  CurrencyAll = CurrencyMain | CurrencyOthers | CurrencyUsd | CurrencyEur | CurrencyCny | CurrencyChf,

  /**
   * Все флаги, используется совместно со снятием флагов
   */
  All = TypeAll | WithdrawAll | DepositAll | StateAll | CurrencyAll
}
